export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_34-1302fa4d484b136be7a67ed9300ed630.jpg";